import {Component, OnInit} from '@angular/core';
import {ViewTicketResponseService} from '../../../shared/services/view-ticket-response.service';

@Component({
  selector: 'app-view-ticket-response',
  templateUrl: './view-ticket-response.component.html',
  styleUrls: ['./view-ticket-response.component.scss']
})
export class ViewTicketResponseComponent implements OnInit {
  submitting = false;
  viewTicketResponses = [];
  total: any = 0;

  constructor(public viewTicketResponsesService: ViewTicketResponseService) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.get();
  }

  get(params: any = {}) {
    this.submitting = true;
    this.viewTicketResponses = [];
    this.viewTicketResponsesService.get(params).subscribe(data => {
      if (data && data.length > 0) {
        this.viewTicketResponses = data;
        this.triggerScroll();
      } else {
        this.viewTicketResponses = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }
}
